// extracted by mini-css-extract-plugin
export var plansPerksList = "PerksListContainer_plansPerksList__rCidW";